import React from "react";
import { TextField } from "formik-material-ui";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import Box from "@material-ui/core/Box";
import { Formik, Form, Field, FormikProps } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { apiEndpoint } from "../../../constants/api.constants";

export default () => {
    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .email("Invalid email")
            .required("Required"),
    });
    const { enqueueSnackbar } = useSnackbar();
    let history = useHistory();
    return (
        <Formik
            initialValues={{
                email: "",
            }}
            onSubmit={async (values, {setStatus}) => {
                const body = `email=${values.email}`;
                try {
                    await fetch(apiEndpoint+"passwordresettokens", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        },
                        body: body
                    }).then(res => {
                        if(res.status === 200) {
                            setStatus({success: true});
                            enqueueSnackbar("Email was sent", {
                                autoHideDuration: 3000,
                            });
                            history.push({
                                pathname: "/forgotPasswordSuccess",
                                state: { email: values.email}
                            });
                        }
                        else {
                            setStatus({success: false});
                            enqueueSnackbar("You've inputted an incorrect email", {
                                variant: "error",
                                autoHideDuration: 3000,
                            });
                        }
                    });
                } catch (error) {
                    enqueueSnackbar("Error while sending email", {
                        variant: "error",
                        autoHideDuration: 3000,
                    });
                    setStatus({success: false});
                }
            }}
            validationSchema={validationSchema}
        >
            {
                (props: FormikProps<{email: string}>) => (
                    <Form>
                        <Box
                            display="flex"
                            flexDirection="column"
                            width="100%"
                            marginBottom="16px"
                        >
                            <Field
                                component={TextField}
                                name="email"
                                label="Email Address"
                                variant="outlined"
                                color="secondary"
                                type="email"
                                margin="normal"
                                onChange={props.handleChange}
                                value={props.values.email}
                                data-testid="emailInput"
                            />
                        </Box>
                        <Box
                            marginBottom={"10pt"}
                        >
                            <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                                data-testid="submitButton"
                                fullWidth
                            >
								Send Reset Link
                            </Button>
                        </Box>
                        <Link to="/login/?login=true" style={{textDecoration: "none"}}>
                            <Button
                                color="default"
                                variant="contained"
                                type="submit"
                                data-testid="submitButton"
                                fullWidth
                            >
								Have an account? Login
                            </Button>
                        </Link>
                    </Form>
                )
            }
        </Formik>
    );
};
